<template>
    <button type="button" @click="back()" class="btn btn-outline-primary btn-lg"><i
        v-bind:class="$t('btn.back.icon')"></i> {{ $t('btn.back.label') }}
    </button>

</template>

<script>
export default {
    name: "back-btn",
    props: ['path'],
    methods: {
        back() {
            if (this.path) {
                this.$router.push(this.path)
            } else {
                this.$router.go(-1)
            }
        }
    }

}
</script>

<style scoped>
button {
    font-weight: normal !important;
}
</style>
